export default function pageTint() {
    const img = document.querySelector("[data-tint-source]");
    if (!img) return;

    const apply = () => {
        try {
            const c = document.createElement("canvas");
            const w = (c.width = 16);
            const h = (c.height = 16);
            const ctx = c.getContext("2d");
            ctx.drawImage(img, 0, 0, w, h);
            const d = ctx.getImageData(0, 0, w, h).data;
            let r = 0, g = 0, b = 0, n = 0;
            for (let i = 0; i < d.length; i += 4) {
                r += d[i]; g += d[i + 1]; b += d[i + 2]; n++;
            }
            r /= n; g /= n; b /= n;
            const paper = [251, 250, 246];
            const k = 0.32;
            const mix = (chan, base) => Math.round(base * (1 - k) + chan * k);
            const target = document.querySelector(".gh-viewport") || document.body;
            target.style.setProperty(
                "--tint",
                `rgb(${mix(r, paper[0])}, ${mix(g, paper[1])}, ${mix(b, paper[2])})`
            );
        } catch (e) {
            return;
        }
    };

    if (img.complete && img.naturalWidth) apply();
    else img.addEventListener("load", apply);
}
